// extracted by mini-css-extract-plugin
export default {"philLink":"LogoRoute_philLink__okiGH","NavbarScroller":"LogoRoute_NavbarScroller__HVoNE"};